import React from "react";
import PropTypes from "prop-types";

function InterviewList(props) {
  const { user_name, blogUrl, interviews } = props;

  return interviews.length > 0 && (
    <span className='border-top-stripe-sm'>
      <section className='row d-flex justify-content-center' id='interview' name='interview'>
        <h2 className='col-12 col-sm-10'>INTERVIEW</h2>
        {interviews.map((interview, index) => {
          return index === 0 && (
            <a
              key={interview.id}
              id={`link-user-interview-${user_name}`}
              className='col-12 col-sm-10 row d-flex justify-content-center'
              target='_blank'
              href={interview.url}
              rel='noopener noreferrer'
            >
              <div className='col-12 col-lg-6 interview-cover-box'>
                <img className='interview-cover' src={interview.image} alt={interview.title} />
              </div>
              <div className='col-12 col-lg-6'>
                <h3>{interview.title}</h3>
                <span>{`from: ${blogUrl}`}</span>
              </div>
            </a>
          );
        })}
      </section>
    </span>
  );
}

InterviewList.propTypes = {
  user_name: PropTypes.string.isRequired,
  blogUrl: PropTypes.string.isRequired,
  interviews: PropTypes.arrayOf(PropTypes.object)
};

InterviewList.defaultProps = {
  interviews: []
};

export default InterviewList;
